import Fetch, { V6 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';

const DEFAULT_GET_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

const getCheckPassword = () => {
  const resourceUrl = `${V6}check-password/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message);
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export default getCheckPassword;
